(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('old-performances', {
            parent: 'dashboard',
            url: '/performances',
            data: {
                authorities: []
            },
            views: {
                'content@main': {
                    templateUrl: 'app/performances/performances.html',
                    controller: 'PerformancesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('performances');
                    return $translate.refresh();
                }]
                // domain: ['Principal', 'TabDomains', '$q', function (Principal, TabDomains, $q) {
                //     var deferred = $q.defer();
                //     Principal.identity().then(function (account) {
                //         deferred.resolve(TabDomains.get({id: account.context.id}));
                //     });
                //     return deferred.promise;
                //
                //
                // }]
            }
        });
    }
})();
